import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { Icon, IconType } from "../../../../icons";
import { IEquipment } from "../../../../hooks/equipments";

export const EquipmentCard: FunctionComponent<IEquipmentCardProps> = ({
  equipment,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  return (
    <Card className={styles.container} sx={{ height: 70 }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onContextMenu={onContextMenu}
        onClick={onClick}
      >
        <Card className={styles.defaultIcon}>
          <Icon type={IconType.SpeakerGroup} />
        </Card>
        <Stack className={styles.rightContainer}>
          <p className={styles.name}>{equipment.name}</p>
          <p className={styles.description}>{equipment.description}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IEquipmentCardProps {
  equipment: IEquipment;
  selected?: boolean;
  onClick: (event: React.MouseEvent) => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
